import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"
import * as am5 from "@amcharts/amcharts5"
import * as am5xy from "@amcharts/amcharts5/xy"
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import {useEffect} from "react"
import {SpinnerGrid} from "../../shared/CommonItems"

export const StackBarChartTest = () => {
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const testTypeCountDetail = useAppSelector((state: RootState) => state.containers.dashboard.testtypeCountDetail)
    const isLoadingTestTypeCount = useAppSelector(
        (state: RootState) => state.containers.dashboard.isLoadingTestTypeCount,
    )

    useEffect(() => {
        if (selectedDealer && testTypeCountDetail) {
            TestTypeCountChart(testTypeCountDetail)
        }
    }, [testTypeCountDetail, selectedDealer])

    const maybeDisposeRoot = (divId: string) => {
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom != null && root.dom.id === divId) {
                root.dispose()
            }
        })
    }
    const TestTypeCountChart = (chartdata: any) => {
        maybeDisposeRoot("STACKBARCHARTDIV")

        const root = am5.Root.new("STACKBARCHARTDIV")

        root.setThemes([am5themes_Animated.new(root)])

        const chart: any = root.container.children.push(
            am5xy.XYChart.new(root, {
                paddingTop: 25,
                layout: root.verticalLayout,
            }),
        )
        am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "Top 5 Tests",
        })
        chart.get("colors").set("colors", [
            am5.color(0x01b8aa), //pass
            am5.color(0xa66999), //prs
            am5.color(0xfd625e), //fail
        ])

        const yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "testPackage",
                renderer: am5xy.AxisRendererY.new(root, {
                    minGridDistance: 10,
                }),
                tooltip: am5.Tooltip.new(root, {}),
            }),
        )

        yAxis.data.setAll(chartdata)

        const xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererX.new(root, {}),
            }),
        )

        const legend = chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                x: am5.percent(60),
            }),
        )

        const stackTestCodeSeries = (name: string, fieldName: string) => {
            const series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name,
                    stacked: true,
                    xAxis,
                    yAxis,
                    baseAxis: yAxis,
                    valueXField: fieldName,
                    categoryYField: "testPackage",
                }),
            )

            series.columns.template.setAll({
                tooltipText: "[#000]{testDescription} {valueX} [/]",
                tooltipY: am5.percent(95),
                tooltipX: am5.percent(90),
            })
            series.data.setAll(chartdata)
            series.appear()
            series.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Label.new(root, {
                        fontSize: 12,
                        text: "{valueX} ",
                        fill: root.interfaceColors.get("alternativeBackground"),
                        centerY: am5.p50,
                        centerX: am5.p50,
                        populateText: true,
                    }),
                })
            })
            series.columns.template.onPrivate("width", function (width: any, target: any) {
                am5.array.each(target.dataItem.bullets, function (bullet: any) {
                    if (width === 0) {
                        bullet.get("sprite").hide()
                    } else {
                        bullet.get("sprite").show()
                    }
                })
            })

            legend.data.push(series)
        }

        stackTestCodeSeries("PASS", "noOfPASS")
        stackTestCodeSeries("PRS", "noOfPRS")
        stackTestCodeSeries("FAIL", "noOfFAIL")
        chart.set("cursor", am5xy.XYCursor.new(root, {}))

        xAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )

        yAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )
    }

    return (
        <>
            {isLoadingTestTypeCount && <SpinnerGrid />}
            <div className="h-100" id="STACKBARCHARTDIV"></div>
        </>
    )
}
